var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.18528 2.0813L17.1349 8.75353C17.2757 8.82093 17.3946 8.92678 17.4778 9.05887C17.561 9.19096 17.6051 9.34389 17.6051 9.5C17.6051 9.65611 17.561 9.80904 17.4778 9.94113C17.3946 10.0732 17.2757 10.1791 17.1349 10.2465L3.18528 16.9187C3.04222 16.9873 2.88246 17.0133 2.72503 16.9936C2.56761 16.974 2.41915 16.9095 2.29734 16.8078C2.17554 16.7062 2.08551 16.5717 2.03799 16.4203C1.99048 16.2689 1.98747 16.1071 2.02932 15.9541L3.42494 10.8377C3.44203 10.775 3.47719 10.7187 3.52605 10.6758C3.57491 10.633 3.6353 10.6055 3.6997 10.5967L10.4593 9.67842C10.4875 9.67447 10.5142 9.66331 10.5368 9.64603C10.5594 9.62875 10.5772 9.60593 10.5884 9.57978L10.6003 9.53807C10.6056 9.50111 10.5981 9.46346 10.5793 9.43125C10.5604 9.39904 10.5312 9.37416 10.4964 9.36064L10.46 9.35071L3.70698 8.43309C3.6427 8.42421 3.58245 8.39663 3.53372 8.35378C3.48499 8.31094 3.44993 8.25471 3.43289 8.1921L2.02932 3.04592C1.98747 2.89289 1.99048 2.73106 2.03799 2.5797C2.08551 2.42833 2.17554 2.29382 2.29734 2.19217C2.41915 2.09053 2.56761 2.02603 2.72503 2.00638C2.88246 1.98672 3.04222 2.01273 3.18528 2.0813V2.0813Z",
    fill: "#CBD5E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/Send.f1af5b07977f7832025f52db21e63ab1.svg";
export { ForwardRef as ReactComponent };